exports = module.exports = require("../../../../node_modules/@angular/cli/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".keyboard-container {\n  width: 100%;\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  background: rgba(255, 255, 255, 0.9);\n  padding: 30px 0;\n  -webkit-tap-highlight-color: transparent;\n  text-align: center; }\n  .keyboard-container:hover {\n    cursor: pointer; }\n\n.keyboard-row {\n  margin: 0px auto; }\n\n.key-button {\n  font-size: 40px;\n  line-height: 50px;\n  padding: 10px;\n  color: #696969;\n  min-width: 72px;\n  border: 1px solid #9A9A9A;\n  border-radius: 8px;\n  text-align: center;\n  margin: 4px;\n  background-color: #ffffff;\n  -webkit-tap-highlight-color: transparent;\n  outline: none; }\n\n.key-button.spacebar {\n  width: 250px; }\n\n.key-button:active {\n  background-color: #67b749;\n  color: #ffffff; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Magento2/gs-kiosk/src/app/shared/keyboard/keyboard.component.scss
// module id = ../../../../../src/app/shared/keyboard/keyboard.component.scss
// module chunks = main